import 'sbf-design-system-component/forms/base';
import 'sbf-design-system/js/lib/parsley';
import banner from 'sbf-design-system-component/banners/banner';
import '../application';

$(document).ready(() => {
  // Form submit button click action.
  $('#registration-form button').on('click', (event) => {
    event.preventDefault();
    // If in page edit mode.
    if (window.sbf.ce && window.sbf.ce.init) {
      return;
    }
    // Form field validation check.
    if (!validateForm()) {
      return;
    }
    $('#registration-form').submit();
  });
  // Server-side error message.
  if ($('.hidden-error').length) {
    banner.showError($('.hidden-error').text(), true, 4000);
  }
});

/**
 * Validate form fields.
 *
 * @return    bool     Whether or not all form field values are valid. Indicates
 *                     whether or not it is okay for the form to submit.
 */
const validateForm = () => {
  let returnValue = true;

  $('.inline-input').find('[required]').each(function () {
    const $this = $(this);

    if (!$this.parsley().isValid()) {
      banner.showError($this.attr('data-parsley-error-message'), true, 4000);
      if (!window.navigator.userAgent.match(/iPhone/i)) {
        $this.focus();
      }
      $this.addClass('field--invalid');
      returnValue = false;

      return false;
    }
  });

  return returnValue;
};
